import call from "./call";
import { User } from "../Models/user";

export const login = async (email: string, password: string) => {
  const response = await call.post(
    "/v1/auth/login/",
    {
      email,
      password,
    },
    {
      snack: {
        error: "auth.loginError",
      },
    }
  );
  return response.data;
};

export const passwordResetRequest = async (email: string) => {
  const response = await call.post(
    "/v1/auth/password-reset-request/",
    {
      email,
    },
    {
      snack: {
        404: "auth.passwordResetNotFound",
        error: "auth.passwordResetError",
      },
    }
  );
  return response.data;
};

export const passwordResetSubmit = async (
  password: string,
  token: string | null
) => {
  const response = await call.post(
    "/v1/auth/password-reset-submit/",
    {
      password,
      token,
    },
    {
      snack: {
        success: "auth.passwordResetSuccess",
        error: "auth.passwordResetError",
      },
    }
  );
  return response.data;
};

export const checkAuth = async () => {
  const response = await call.get("/v1/auth/check_auth/");
  return response;
};

export const checkAdmin = async () => {
  const response = await call.get("/v1/auth/check_admin/");
  return response;
};

export const getUser = async (): Promise<User> => {
  const { data } = await call.get<User>("/v1/user/", {
    snack: {
      error: "auth.fetchUserError",
    },
  });
  return data;
};

export const toggleMaintenanceMode = async (
  enabled: boolean
): Promise<{ maintenance_mode: boolean }> => {
  const { data } = await call.put<{ maintenance_mode: boolean }>(
    "/v1/app_settings/maintenance_mode/",
    { maintenance_mode: enabled },
    {
      snack: {
        success: "maintenance.toggleSuccess",
        error: "maintenance.toggleError",
      },
    }
  );
  return data;
};

export const loginAsAdmin = async (user_id: string) => {
  const response = await call.post(
    "/v1/auth/own_account/",
    {
      user_id,
    },
    {
      snack: {
        success: "auth.loginAsAdminSuccess",
        error: "auth.loginAsAdminError",
      },
    }
  );
  return response.data;
};
